module.exports = __webpack_public_path__ + "assets/f6b037ad4885561ac791d08d0c29079c.png";